var render = function render(){var _vm=this,_c=_vm._self._c;return _c('slice',{staticClass:"slice--spacing",class:[
    `spacing--${_vm.block.level}`,
    `spacing--desktop--${_vm.block.level_desktop}`,
  ],attrs:{"id":_vm.block._key,"detect-in-screen":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }